/**
 * Mutation to delete a marketplace_seller_feature record (used for cascade cleanup)
 */
const deleteSellerFeatureMutation = `
mutation DeleteSellerFeature($id: ID!) {
  deleteMarketplace_seller_feature(input: { id: $id }) {
    marketplace_seller_feature {
      objectId
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default deleteSellerFeatureMutation;
